<p-progressSpinner  class="main-progress" *ngIf="loading"></p-progressSpinner>
<router-outlet></router-outlet>
